import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import { Form } from '@ant-design/compatible';
import NoticeStoreSaveWrap from '../../views/notice/store/save/NoticeStoreSaveWrap';
import { noticeStoreActions } from '../../store/modules/notice/store';
import { OFFICE_FILE_REX_PATTERN_LIST } from '../../constants/service/common/utilConstants';

class NoticeStoreSaveContainer extends Component {
  /**
   *  에디터에서 이미지 추가시 사용되는 메소드
   */
  insertImageCallback = (file) => {
    const limitSize = 1024 * 1024 * 2;
    if (file.size > limitSize) {
      message.error('이미지용량은 2MB 미만으로 제한합니다.');
      return false;
    }
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve({ data: { link: e.target.result } });
      reader.onerror = (e) => reject(e);
      reader.readAsDataURL(file);
    });
  };

  /**
   *  첨부파일 업로드
   */
  onChangeAttachment = (e) => {
    e.preventDefault();
    let files;
    if (e.target) {
      files = e.target.files;
    }

    if (!files[0]) return false;

    const pattern = new RegExp(OFFICE_FILE_REX_PATTERN_LIST.map((p) => p.source).join('|'));
    /**
     *  file 형식 체크
     */
    if (!pattern.test(files[0].type)) {
      message.error('pdf 파일 또는 MS OFFICE 파일을 올려주세요!!');
      e.target.value = null;

      return false;
    }

    /**
     *  파일 존재 체크
     */
    if (!files || !files[0]) return false;

    const limitSize = 1024 * 1024 * 10;
    if (files[0].size > limitSize) {
      message.error('이미지용량은 10MB 미만으로 제한합니다.');
      return false;
    }

    this.props.setData({
      path: ['noticeStore', 'noticeStoreInfo', 'attachment'],
      value: [files[0]],
    });

    e.target.value = null;
  };

  /**
   *  상점 공지사항 추가하기/편집하기
   */
  onSubmit = () => {
    const { form, onSubmit, noticeStoreInfo, storeNoticeId } = this.props;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 100 } }, (err) => {
      if (err) return;

      /**
       *  본문 체크하기
       */
      if (!noticeStoreInfo.content || noticeStoreInfo.content === '') {
        message.error('본문은 필수입니다.');
        return;
      }

      /**
       *  편집일 경우에는 noticeStoreId 도 서버로 보내야 한다.
       */
      onSubmit({ ...noticeStoreInfo, storeNoticeId });
    });
  };

  render() {
    const { noticeStoreInfo, noticeStoreLabelList, isEdit, pageName, form, setData } = this.props;

    return (
      <NoticeStoreSaveWrap
        form={form}
        isEdit={isEdit}
        pageName={pageName}
        noticeStoreInfo={noticeStoreInfo}
        noticeStoreLabelList={noticeStoreLabelList}
        onSubmit={this.onSubmit}
        insertImageCallback={this.insertImageCallback}
        onChangeAttachment={this.onChangeAttachment}
        setData={setData}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    noticeStoreInfo: state.noticeStore.noticeStore.noticeStoreInfo,
    noticeStoreLabelList: state.noticeStore.noticeStore.noticeStoreLabelList,
  };
};

const mapDispatchToProps = {
  setData: noticeStoreActions.setData,
  addNoticeStore: noticeStoreActions.addNoticeStore,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(NoticeStoreSaveContainer));
